import React, {useState} from 'react';
import registeredComponent from "../../utils/registeredComponent";

const FactsUserAccounts = ({xml}) => {
  const parser = new DOMParser();
  const dom = parser.parseFromString(xml, 'application/xml');
  const usernames = Array.from(
    new Set(
      Array.from(
        dom.getElementsByTagName('Username')
      ).map(e => e.textContent.trim()).sort()
    )
  );

  return <React.Fragment>
    <h2>FACTS User Accounts</h2>

    {
      usernames.length > 0 && <React.Fragment>
        <p>These email addresses were found in the FACTS XML</p>
        <ul>
          {
            usernames.map((username) =>
              <li key={username}>{username}</li>
            )
          }
        </ul>
      </React.Fragment> || <p>No email addresses were found in the FACTS XML</p>
    }
  </React.Fragment>;
}

export default registeredComponent('FactsUserAccounts')(FactsUserAccounts);
